import {
    getBrandId,
    getCurrentTheme,
} from '~shared/utils/user';
import { pushToDataLayer } from '../../shared/utils/google-tag-manager';

const SKIN_PER_BRAND = {
    86: 'brand86', //US brand Colorado
    89: 'brand86', //US brand Virginia,
    90: 'brand86', //US brand Indiana,
    91: 'brand86', //US brand Michigan,
};

const THEME_CLASS = {
    1: 'dark-theme',
    2: 'light-theme',
};

const getSkinName = () => SKIN_PER_BRAND[getBrandId()] || 'default';

export const getThemeClass = (themeId = null) => {
    const theme = themeId ?? getCurrentTheme();

    return THEME_CLASS[theme];
};

export const pushGTMTheme = () => {
    pushToDataLayer({
        event: 'SP_LOAD_THEME',
        'theme': getThemeClass(),
    });
};

export const loadSkinVariables = async () => {
    const skinName = getSkinName();

    await import(
        /* webpackChunkName: "skins/[request]" */
        `../styles/skins/${skinName}.scss`
    );
};
